import React from "react";
import { Container, ListItem } from "../../components";
import { Circle3 } from "../../assets";

const HowItWorks = () => {
  return (
    <section className="bg-[#0B1956] px-6 text-white relative py-10 lg:py-20 scroll-mt-32" id="HowItWorks">
      <Container className="z-[1]">
        <div className="max-w-[572px] mb-9 lg:mb-20 relative z-[2]">
          <div>
            <p className="text-[#ADD0E3]">How it works</p>
          </div>
          <h2 className="text-3xl lg:text-5xl font-bold my-3 ">
            Book health &amp; beauty Heros on Meind Therapy
          </h2>
          <p className="text-lg font-normal">
            Find trusted wellness, spa, massage, and beauty professionals, and
            book appointments in a few simple steps.
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-6">
          <CardStep
            step={1}
            title="Create Your Profile"
            description="Clients sign up to explore health and beauty services while Heros build profiles that highlight specialties, availability, and experience."
          />
          <CardStep
            step={2}
            title="Find the Perfect Match"
            description="Browse Meind Therapy Heros by wellness, beauty, spa, or massage specialty and availability, while providers receive booking requests that fit their expertise."
          />
          <CardStep
            step={3}
            title="Book and Get Ready"
            description="Clients book health and beauty appointments at convenient times. Heros confirm bookings, manage schedules, and deliver sessions securely."
          />
          <CardStep
            step={4}
            title="Manage Progress and Feedback"
            description="Share feedback after every session while Heros improve client care and grow their health and beauty practice on Meind."
          />
        </div>
      </Container>
      <img
        src={Circle3}
        className="absolute top-0 right-0 w-[200px] h-[183px] md:w-[unset] md:h-[unset]"
        alt=""
        loading="lazy"
        aria-hidden="true"
      />
    </section>
  );
};

export default HowItWorks;

const CardStep = ({ step, title, description }: any) => {
  return (
    <div className="border-[0.5px] border-[#D7D4D2] rounded-3xl p-6">
      <div className="w-10 h-10 rounded-full bg-white font-bold text-lg flex justify-center items-center text-black mb-6">
        {step}
      </div>
      <ListItem title={title} description={description} />
    </div>
  );
};
